var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 93,
    viewBox: "0 0 87 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M80.3382 71.567C76.0916 82.2087 69.0888 89.1556 60.9534 91.2481C53.4656 92.8216 43.9619 89.2657 33.5294 80.6934C23.0559 72.9241 13.554 63.0189 7.20882 53.2403C1.5258 44.4616 0.104363 34.6696 4.69304 24.9885C10.5099 15.3586 20.8338 7.56895 32.3416 3.40543C43.9037 -0.0191591 56.1197 1.09859 66.257 7.79248C76.3592 15.1747 82.635 26.0885 84.739 37.6063C87.0957 48.9069 85.6976 60.9821 80.3382 71.567Z",
    stroke: "#5A42ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "10 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector23);
export default __webpack_public_path__ + "static/media/Vector-23.be706e087dcf33f87b701e118e9ca22c.svg";
export { ForwardRef as ReactComponent };